import axios from "axios";
import { config } from "../../../../config/envs";

export const getAllProducts = ()=>{
	return axios.get(config.app.adminBaseUrl + "/products");
}

export const getByIdProduct = (id)=>{
	return axios.get(config.app.adminBaseUrl + `/products/${id}`);
}


export const updateProduct = (id, data)=>{
	return axios.put(config.app.adminBaseUrl + `/products/${id}`, data);
}
